module.exports = __webpack_public_path__ + "static/Policies-dbcf8bab7f5397dd10d2b9765bacc0a7.pdf";